import React, { useEffect, useState } from 'react';
import { FlatList } from 'react-native';
import type { EventProps, LeagueProps, MatchProps, TournamentProps } from "../../types"
import { Checkbox } from '../../Components';
import DropDown from '../../Components/Dropdown';
import moment from 'moment-mini';
import { Button, Text, View } from '../../Components/Themed';
import SearchBox from '../../Components/SearchBox';

type ContestSelectorProps = {
    leagues:LeagueProps[],
    maxHeight?:number,
    events:EventProps[],
    tournaments:TournamentProps[],
    matches:MatchProps[],
    selected_events:string[],
    onSelectEvent:(e:EventProps) => void,
    onDeselectEvent:(e:EventProps) => void,
    selected_tournaments:string[],
    onSelectTournament:(t:TournamentProps) => void
    selected_matches:string[],
    onSelectMatch:(m:MatchProps) => void
}

const ContestSelector = ({ leagues, events, onSelectEvent, selected_events, onDeselectEvent }:ContestSelectorProps) => {
    const [ selector_data, setSelectorData ] = useState<{
        selected_league?:LeagueProps,
        search_value:string
    }>({
        search_value: ''
    });
    const { selected_league, search_value } = selector_data;

    useEffect(() => {
        if(!selected_league){ setSelectorData({ ...selector_data, selected_league: leagues.find(l => l.priority == 1) }) }
    },[leagues.length]);

    let filtered_events = events.filter(e => e.league_id == selected_league?.league_id).sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix());
    if(search_value){
        filtered_events = filtered_events.filter(e => `${e.away?.market_name} ${e.away?.name} ${e.home?.market_name} ${e.home?.name}`.toLowerCase().includes(search_value.toLowerCase()))
    }

    const renderEvents = (data:{ item:EventProps, index:number }) => {
        const selected = selected_events.find(se => se == data.item.event_id) ? true : false;
        return (
            <Button style={{ padding:2, flexDirection:'row', alignItems:'center' }} onPress={() => selected ? onDeselectEvent(data.item) : onSelectEvent(data.item)}>
                <Checkbox checked={selected} disabled onSelect={() => console.log('')}/>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text size={12} weight='bold' theme='h1'>{data.item.event_title}</Text>
                    <Text style={{ marginTop:3 }} theme='light'>{data.item.time_detail == 'scheduled' ? moment(data.item.scheduled_datetime).format('MMM DD : hh:mm a') : data.item.time_detail}</Text>
                </View>
            </Button>
        )
    }


    return (
        <View>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Select Contest</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Use league dropdown to filter</Text>
                </View>
                <DropDown
                    selected_value={selected_league?.league_name ?? ''}
                    dropdown_options={[
                        { value: 'league', eligible_options: leagues.sort((a,b) => a.priority - b.priority).map(l => l.league_name) }
                    ]}
                    onOptionSelect={(option) => {
                        let league = leagues.find(l => l.league_name == option);
                        setSelectorData({ ...selector_data, selected_league: league })
                    }}
                />
            </View>
            <View type='body' style={{ maxHeight:300, overflow:'scroll' }}>
                {selected_league ?
                <SearchBox
                    style={{ padding:5 }}
                    button_style={{ padding:8 }}
                    onChange={(text) => setSelectorData({ ...selector_data, search_value: text })}
                />
                :<></>}
                <FlatList
                    data={filtered_events}
                    renderItem={renderEvents}
                    keyExtractor={(item) => item.event_id.toString()}
                />
            </View>
        </View>
    )
}

export default ContestSelector